import { voucherConstants } from "../constants/voucherConstants";

const initialState = {
  sending: false,
  voucherResponse: {},
  offerslist: {},
  voucherlist: {},
  redeemvoucher: {},
  emailResponse: {},
  error: {},
  autoEmailData: {},
  checkQty: {},
  voucherStatus: {},
  merchantdealList: {},
  merchantVoucherList: {},
  voucherDetails: {},
  editVoucherData: {},
    editAVoucherData: {},
  merchantAllVouchers: {},
  tracknigResponse: {},
  uploadHistory: "",
  exportList: {},
  transfer: {},
  refundStatus: {},
  orderList: [],
  resendStatus: {},
  archivevoucherlist: {},
  archivevoucherDetails: {},
  merchantarchiveVoucherList:{},
};

export default function voucherReducer(state = initialState, action) {
  switch (action.type) {
    case voucherConstants.ADD_VOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.ADD_VOUCHER_SUCCESS:
      return {
        ...state,
        voucherResponse: action.data,
      };
    case voucherConstants.ADD_VOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_ORDER_HISTORY_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_ORDER_HISTORY_SUCCESS:
      return {
        ...state,
        orderList: action.orderdata.data,
        sending: false,
      };
    case voucherConstants.GET_ORDER_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
        sending: false,
      };
    case voucherConstants.GET_DEAL_VOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_DEAL_VOUCHER_SUCCESS:
      return {
        ...state,
        offerslist: action.data,
      };
    case voucherConstants.GET_DEAL_VOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_VOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_VOUCHER_SUCCESS:
      return {
        ...state,
        voucherlist: action.data,
      };

    case voucherConstants.GET_VOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_AVOUCHER_SUCCESS:
      return {
        ...state,
        archivevoucherlist: action.data,
      };
    case voucherConstants.GET_AVOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.REDEEM_VOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.REDEEM_VOUCHER_SUCCESS:
      return {
        ...state,
        redeemvoucher: action.data,
      };
    case voucherConstants.REDEEM_VOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.CHECK_EMAIL_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        emailResponse: action.data,
      };
    case voucherConstants.CHECK_EMAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.AUTO_EMAIL_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.AUTO_EMAIL_SUCCESS:
      return {
        ...state,
        autoEmailData: action.data,
      };
    case voucherConstants.AUTO_EMAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.CHECK_QTY_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.CHECK_QTY_SUCCESS:
      return {
        ...state,
        checkQty: action.data,
      };
    case voucherConstants.CHECK_QTY_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.UPDATE_STATUS_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.UPDATE_STATUS_SUCCESS:
      return {
        ...state,
        voucherStatus: action.data,
      };
    case voucherConstants.UPDATE_STATUS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_MERCHANT_DEAL_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_MERCHANT_DEAL_SUCCESS:
      return {
        ...state,
        merchantdealList: action.data,
      };
    case voucherConstants.GET_MERCHANT_DEAL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_MERCHANT_VOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_MERCHANT_VOUCHER_SUCCESS:
      return {
        ...state,
        merchantVoucherList: action.data,
      };
    case voucherConstants.GET_MERCHANT_VOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case voucherConstants.GET_MERCHANT_ARCHIVEVOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_ARCHIVEMERCHANT_VOUCHER_SUCCESS:
      return {
        ...state,
        merchantarchiveVoucherList: action.data,
      };
    case voucherConstants.GET_MERCHANT_ARCHIVEVOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_MERCHANT_ALLVOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_MERCHANT_ALLVOUCHER_SUCCESS:
      return {
        ...state,
        merchantAllVouchers: action.data,
      };
    case voucherConstants.GET_MERCHANT_ALLVOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_VOUCHER_DETAIL_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_VOUCHER_DETAIL_SUCCESS:
      return {
        ...state,
        voucherDetails: action.data,
      };
    case voucherConstants.GET_VOUCHER_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.GET_AVOUCHER_DETAIL_SUCCESS:
      return {
        ...state,
        archivevoucherDetails: action.data,
      };
    case voucherConstants.GET_AVOUCHER_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case voucherConstants.GET_VOUCHER_SPECIFIC_DETAIL_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_VOUCHER_SPECIFIC_DETAIL_SUCCESS:
      return {
        ...state,
        voucherSpecificDetails: action.data,
      };
    case voucherConstants.GET_VOUCHER_SPECIFIC_DETAIL_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case voucherConstants.EDIT_VOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.EDIT_VOUCHER_SUCCESS:
      return {
        ...state,
        editVoucherData: action.data,
      };
    case voucherConstants.EDIT_VOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.EDIT_AVOUCHER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.EDIT_AVOUCHER_SUCCESS:
      return {
        ...state,
        editAVoucherData: action.data,
      };
    case voucherConstants.EDIT_AVOUCHER_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case voucherConstants.UPLOAD_TRACKING_NO_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.UPLOAD_TRACKING_NO_SUCCESS:
      return {
        ...state,
        tracknigResponse: action.data,
      };
    case voucherConstants.UPLOAD_TRACKING_NO_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case voucherConstants.GET_UPLOAD_TRACKING_HISTORY_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.GET_UPLOAD_TRACKING_HISTORY_SUCCESS:
      return {
        ...state,
        uploadHistory: action.data,
      };
    case voucherConstants.GET_UPLOAD_TRACKING_HISTORY_FAILURE:
      return {
        ...state,
        error: action.error,
      };

    case voucherConstants.EXPORT_PURCHASER_LIST_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.EXPORT_PURCHASER_LIST_SUCCESS:
      return {
        ...state,
        exportList: action.data,
      };

      case voucherConstants.EXPORT_ARCHIVEPURCHASER_LIST_SUCCESS:
      return {
        ...state,
        exportList: action.data,
      };
    case voucherConstants.EXPORT_PURCHASER_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.VOUCHER_TRANSFER_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.VOUCHER_TRANSFER_SUCCESS:
      return {
        ...state,
        transfer: action.data,
      };
    case voucherConstants.VOUCHER_TRANSFER_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.POST_REFUND_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.POST_REFUND_SUCCESS:
      return {
        ...state,
        refundStatus: action.data,
      };
    case voucherConstants.POST_REFUND_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.POST_RESEND_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.POST_RESEND_SUCCESS:
      return {
        ...state,
        resendStatus: action.data,
      };
    case voucherConstants.POST_RESEND_FAILURE:
      return {
        ...state,
        error: action.error,
      };
case voucherConstants.POST_ARESEND_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.POST_ARESEND_SUCCESS:
      return {
        ...state,
        resendStatus: action.data,
      };
    case voucherConstants.POST_ARESEND_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.POST_DEACTIVERECURRUING_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.POST_DEACTIVERECURRUING_SUCCESS:
      return {
        ...state,
        deactivaterec: action.data,
      };
    case voucherConstants.POST_DEACTIVERECURRUING_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.POST_ACTIVERECURRUING_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.POST_ACTIVERECURRUING_SUCCESS:
      return {
        ...state,
        activaterec: action.data,
      };
    case voucherConstants.POST_ACTIVERECURRUING_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case voucherConstants.POST_UPDATERECURRING_REQUEST:
      return {
        sending: true,
      };
    case voucherConstants.POST_UPDATERECURRING_SUCCESS:
      return {
        ...state,
        updaterec: action.data,
      };
    case voucherConstants.POST_UPDATERECURRING_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/voucherReducer.js